module.exports = __webpack_public_path__ + "img/logo_transparent.37851ba0.png";